/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Exact_Alarm_AllowInputs */

const en_us2_offline_exact_alarm_allow = /** @type {(inputs: Offline_Exact_Alarm_AllowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow`)
};

const pt_br2_offline_exact_alarm_allow = /** @type {(inputs: Offline_Exact_Alarm_AllowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permitir`)
};

const es_419_offline_exact_alarm_allow = /** @type {(inputs: Offline_Exact_Alarm_AllowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permitir`)
};

const pt_pt2_offline_exact_alarm_allow = /** @type {(inputs: Offline_Exact_Alarm_AllowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permitir`)
};

const fr_fr2_offline_exact_alarm_allow = /** @type {(inputs: Offline_Exact_Alarm_AllowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autoriser`)
};

const de_de2_offline_exact_alarm_allow = /** @type {(inputs: Offline_Exact_Alarm_AllowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erlauben`)
};

const it_it2_offline_exact_alarm_allow = /** @type {(inputs: Offline_Exact_Alarm_AllowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consenti`)
};

/**
* | output |
* | --- |
* | "Allow" |
*
* @param {Offline_Exact_Alarm_AllowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_exact_alarm_allow = /** @type {((inputs?: Offline_Exact_Alarm_AllowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Exact_Alarm_AllowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_exact_alarm_allow(inputs)
	if (locale === "es-419") return es_419_offline_exact_alarm_allow(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_exact_alarm_allow(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_exact_alarm_allow(inputs)
	if (locale === "de-DE") return de_de2_offline_exact_alarm_allow(inputs)
	if (locale === "it-IT") return it_it2_offline_exact_alarm_allow(inputs)
	return en_us2_offline_exact_alarm_allow(inputs)
});
export { offline_exact_alarm_allow as "offline.exact_alarm_allow" }